module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alternative-day",
    class: {
      'placeholder alternative-day--placeholder': _vm.placeholder, 'no-availability': _vm.times && !_vm.availableTimes.length
    }
  }, [(!_vm.placeholder) ? [_c('div', {
    staticClass: "alternative-day__header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), (_vm.availableTimes.length) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.seeAvailabilityFor(_vm.day.date)
      }
    }
  }, [_vm._v("See More >")]) : _vm._e(), _vm._v(" "), (!_vm.availableTimes.length) ? _c('span', {
    staticClass: "alternative-day__no-availability"
  }, [_vm._v("No availability")]) : _vm._e()]), _vm._v(" "), (_vm.availableTimes.length) ? _c('div', {
    staticClass: "alternative-day__buttons"
  }, _vm._l((_vm.availableTimes), function(time) {
    return _c('button', {
      key: time.uniqueId,
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.makeAlternativeSelection(_vm.day.date, time)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.DateService.friendlyTime(time.time)))]), _vm._v(" "), (time.isInstant) ? _c('div', {
      staticClass: "alternative-day--instant"
    }, [_c('small', [_c('svg', {
      attrs: {
        "width": "10",
        "height": "10",
        "viewBox": "0 0 1792 1792",
        "title": "Instant Book available"
      }
    }, [_c('path', {
      attrs: {
        "d": "M1333 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"
      }
    })]), _vm._v(" avail.\n                    ")])]) : _c('small', [_vm._v("Enquire")])])
  })) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.placeholder) ? [_c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "alternative-day__cover alternative-day__cover-10"
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167edb72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/altSlot.vue
// module id = 584
// module chunks = 0